import { Button, Col, Modal, Row } from '../common/components'

type EnhanceBenefitModalProps = {
  isEnhanceBenefitModalOpen: boolean
  handleMaybeLaterAnswer: () => void
  handleEnablePremiumAnswer: () => void
  handleEnhanceBenefitModalClose: () => void
}

const EnhanceBenefitModal = ({
  isEnhanceBenefitModalOpen,
  handleMaybeLaterAnswer,
  handleEnablePremiumAnswer,
  handleEnhanceBenefitModalClose,
}: EnhanceBenefitModalProps) => {
  return (
    <Modal
      visible={isEnhanceBenefitModalOpen}
      onCancel={handleEnhanceBenefitModalClose}
      footer={
        <Row justify="end">
          <Button danger={false} size="large" type="default" loading={false} onClick={handleMaybeLaterAnswer}>
            Maybe later
          </Button>
          <Button danger={false} size="large" type="primary" loading={false} onClick={handleEnablePremiumAnswer}>
            Enable Premium+
          </Button>
        </Row>
      }
      closable
    >
      <div className="mb-8 mt-16" style={{ fontSize: '18px', fontWeight: 'bold' }}>
        Enhance your benefit by enabling Premiums + out of pocket expenses
      </div>
      <div className="mb-8" style={{ fontSize: '15px' }}>
        Enabling reimbursements for out of pocket expenses allows your employees to make the most out of their health
        benefits. It’s simple to do, and can be enabled at any time.
      </div>
    </Modal>
  )
}

export default EnhanceBenefitModal
